// import React, { useEffect, useState } from 'react';
// import 'chart.js/auto';
// import './app.css';
// import Appimg from '../../../assets/images/latestreviews.png'
// import { Rating, Box, Skeleton, } from '@mui/material';
// import {  MdDelete } from "react-icons/md";
// import Orders from './LatestOrder';
// import TotalOrdersChart from './TotalOrderChart';
// import DashbaordImgtext from 'components/latestOrder/DashbaordImgtext';
// import Sidebar from 'pages/sideBar/SideBar';
// import img1 from '../../../assets/images/LatestReView.png'
// import img2 from '../../../assets/images/acceptorder.png'
// import img3 from '../../../assets/images/cancel.png'
// import { useSelector } from 'react-redux';
// import axios from 'axios';
// import { formatDate, formatTimeInTimezone } from 'pages/utils/formdatedynamics';
// import { useNavigate } from 'react-router-dom';
// function Dashboard() {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
// const navigate = useNavigate()
//   const fetchData = async () => {
//     const token = localStorage.getItem('accessToken');
//     const apiUrl = 'https://production.washta.com/api/seller/shopReview';

//     try {
//       const response = await axios.get(apiUrl, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       setData(response.data.data.reverse());
//     } catch (err) {
//       if (err.response && err.response.status === 401) {
//         localStorage.clear();
//         navigate('/');
//       } 
//       console.error('Error reponse data:', err);
//     } finally {
//       setLoading(false);
//     }
//   };
//   const handleDelete = async (reviewId, ) => {
//     const token = localStorage.getItem('accessToken');
//     const apiUrl = `https://production.washta.com/api/seller/deleteReview/${reviewId}`
     

//     try {
//       const response = await axios.delete(apiUrl, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       console.log('Delete successful', response.data);
//       fetchData();
//     } catch (err) {
//       console.error('Error deleting:', err.message);
//     }
//   };

//   useEffect(() => {
//     window.scrollTo(0, 0);
//     fetchData();
//   }, []);
//   const stats = useSelector(state => state.stats);
//   return (
//     <div className='mainDiv-all-sideBar'>
//     <div className='div-sidebar'>
// <Sidebar/>
//     </div>
//     <div className='div-Dashbaord'>
//     <h1 className='h1-all-heading'>Dashboard</h1>
//     <div className="dashboard">
     
//       <div className='styles-div'>

// <TotalOrdersChart/>
      
//       {/* <Line data={data} /> */}
//       <div className="stats" style={{gap:20}}>
//         <DashbaordImgtext heading='Total Orders' value={stats?.totalNumberOfOrders || stats?.totalAcceptedOrders}  img={img1}/>
//         <DashbaordImgtext heading='Accepted orders' value={stats?.totalCompletedOrders || stats?.totalAcceptedOrders} img={img3}/>
//         <DashbaordImgtext heading='Cancelled orders' value={stats?.totalCancelledOrders || stats?.totalCancelledOrders} img={img2}/>
//         {stats?.totalRevenue !== undefined && (
//   <DashbaordImgtext heading='Total Revenue' value={stats?.totalRevenue} img={img3} />
// )}
//       </div>
//       {/* <div className="stats" style={{gap:20,justifyContent:'start'}}>
//       {stats?.totalRevenue !== undefined && (
//   <DashbaordImgtext heading='Total Revenue' value={stats?.totalRevenue} img={img3} />
// )}

//       </div> */}
      
//       {/* <LatestReviews/> */}
//       <div className='invoice-border'>
//       <div className='chart-colm-div-heading'> 
//           <img src={Appimg} style={{width:'5%',objectFit:'contain'}}/>
//           <h2 className='main-heading2'>Latest Reviews</h2>
//           </div>
//       {loading ? (
//                 <Box sx={{ width: '100%', marginTop: 1 }}>
//                   {[1, 2, 3].map((index) => (
//                     <Box key={index} sx={{ marginBottom: 2, background: '#747eef9c', borderRadius: 4, paddingTop: 1, paddingBottom: 1 }}>
//                       <Skeleton variant="text" width="20%" height={20} sx={{ marginLeft: 2, background: '#f1f2fd', borderRadius: 1 }} />
//                       <Skeleton variant="rectangular" width="96%" height={40} sx={{ marginBottom: 1, marginLeft: 2, background: '#f1f2fd', borderRadius: 1 }} />
//                       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '-6px', paddingLeft: 2, paddingRight: 2 }}>
//                         <Skeleton variant="text" width="30%" height={20} style={{ background: '#f1f2fd' }} />
//                         <Skeleton variant="rectangular" width={80} height={13} style={{ marginTop: 1, background: '#f1f2fd', borderRadius: 2 }} />
//                       </Box>
//                     </Box>
//                   ))}
//                 </Box>
//               ) : (
//                 data.map((review) => (
//                   <div key={review._id} className="review-box">
//                     <div className='div-rewie-main'>
//                       <h5 className='heading-h5-later'>{review.customerId?.username || 'Anonymous'}</h5>
//                       <Rating name="half-rating-read" value={review.rating || 0} precision={0.5} sx={{ fontSize: 20, color: '#F39D00' }} readOnly />
//                     </div>
                    
//              <p className='paragph-heading addtion-adding'>{review.comment?.text || 'No comment available'}</p>

//                     <div className='div-rewie-main'>
//                       <p className='paragph-heading' style={{color:'#747EEF'}}>{formatDate(review.date) + ' At ' + formatTimeInTimezone(review.date)} </p>
                     
//                             {/* <MdDelete style={{color:'#747EEF',cursor:'pointer',fontSize:23,marginTop:'-10px'}} onClick={() => handleDelete(review._id, null, true)} />
//                           */}
                     
                     
//                     </div>
                    
//                   </div>
//                 ))
//               )}
//       </div>
//       </div>
//       <div className='styles-div-text' >
//         <Orders/>
//       </div>
//     </div>
//     </div>
//     </div>
//   );
// }

// export default Dashboard;

import React, { useState, useEffect, useRef } from 'react';
import './Dashboard.css';
import Sidebar from 'pages/sideBar/SideBar';
const LOCATIONS = {
  all: { label: '📍 All locations (60)', value: 'all' },
  groups: [
    {
      city: 'Abu Dhabi',
      shops: [
        { value: 'abu_dhabi_mall',  label: 'Abu Dhabi Mall',    sub: 'Al Reem Island' },
        { value: 'yas_mall',        label: 'Yas Mall',          sub: 'Yas Island' },
        { value: 'al_wahda',        label: 'Al Wahda Mall',     sub: 'Al Wahda' },
        { value: 'khalidiyah',      label: 'Khalidiyah Mall',   sub: 'Khalidiyah' },
      ],
    },
    {
      city: 'Dubai',
      shops: [
        { value: 'festival_city',   label: 'Dubai Festival City', sub: 'Festival City' },
        { value: 'marina_mall',     label: 'Marina Mall',         sub: 'Dubai Marina' },
        { value: 'mirdif',          label: 'Mirdif City Centre',  sub: 'Mirdif' },
      ],
    },
  ],
};

const STATS_BY_PERIOD = {
  today: {
    orders: 12, accepted: 10, cancelled: 2, revenue: 'AED 5,842', payout: 'AED 5,375',
    grossRaw: 5842, commission: 467, avgOrder: 'AED 46', newCustomers: 47,
    totalCust: 312, repeatRate: '68%',
    ordersDelta: '↑ 3 today', acceptedDelta: '↑ 1 vs yesterday', cancelledDelta: '↓ 1 vs yesterday',
  },
  week: {
    orders: 84, accepted: 76, cancelled: 8, revenue: 'AED 38,940', payout: 'AED 35,825',
    grossRaw: 38940, commission: 3115, avgOrder: 'AED 46', newCustomers: 11,
    totalCust: 312, repeatRate: '71%',
    ordersDelta: '↑ 9 vs last week', acceptedDelta: '↑ 5 vs last week', cancelledDelta: '↓ 2 vs last week',
  },
  month: {
    orders: 127, accepted: 119, cancelled: 8, revenue: 'AED 5,842', payout: 'AED 5,375',
    grossRaw: 5842, commission: 467, avgOrder: 'AED 46', newCustomers: 47,
    totalCust: 312, repeatRate: '68%',
    ordersDelta: '↑ 12 vs last month', acceptedDelta: '↑ 8 vs last month', cancelledDelta: '↓ 1 vs last month',
  },
  all: {
    orders: 1840, accepted: 1720, cancelled: 120, revenue: 'AED 84,600', payout: 'AED 77,832',
    grossRaw: 84600, commission: 6768, avgOrder: 'AED 46', newCustomers: 312,
    totalCust: 312, repeatRate: '68%',
    ordersDelta: 'Since launch', acceptedDelta: 'Total accepted', cancelledDelta: 'Total cancelled',
  },
};

const PEAK_HOURS = [
  { label: '8–10am',  val: 11, pct: 22 },
  { label: '10–12pm', val: 28, pct: 55 },
  { label: '12–2pm',  val: 39, pct: 78 },
  { label: '2–4pm',   val: 45, pct: 90, peak: true },
  { label: '4–6pm',   val: 35, pct: 70 },
  { label: '6–8pm',   val: 19, pct: 38 },
  { label: '8–10pm',  val: 9,  pct: 18 },
];

const DAYS_OF_WEEK = [
  { label: 'Monday',    val: 6.2,  pct: 28 },
  { label: 'Tuesday',   val: 7.1,  pct: 32 },
  { label: 'Wednesday', val: 8.4,  pct: 38 },
  { label: 'Thursday',  val: 12.2, pct: 55 },
  { label: 'Friday',    val: 20.1, pct: 90, peak: true },
  { label: 'Saturday',  val: 18.3, pct: 82 },
  { label: 'Sunday',    val: 9.4,  pct: 42 },
];

const SERVICE_MIX = [
  { label: 'Interior + Exterior', pct: 44, amt: 'AED 2,570' },
  { label: 'Exterior Wash',       pct: 38, amt: 'AED 2,220' },
  { label: 'Full Detail',         pct: 12, amt: 'AED 720'   },
  { label: 'AC Sterilization',    pct: 6,  amt: 'AED 390'   },
];

const CAR_TYPES = [
  { label: 'SUV',   pct: 52, amt: 'AED 3,038', color: '#4a3db8' },
  { label: 'Sedan', pct: 48, amt: 'AED 2,804', color: '#888'    },
];

const ADDONS = [
  { label: 'Tyre Polish added',       pct: 62, note: 'of orders' },
  { label: 'AC Sterilization added',  pct: 18, note: 'of orders' },
  { label: 'Interior upgrade (Ext→)', pct: 24, note: 'of ext orders' },
];

const RATING_TREND = [
  { month: 'Dec', val: 3.8, hi: false },
  { month: 'Jan', val: 4.0, hi: false },
  { month: 'Feb', val: 4.1, hi: false },
  { month: 'Mar', val: 4.3, hi: true  },
  { month: 'Apr', val: 4.5, hi: true  },
  { month: 'May', val: 4.7, hi: true, top: true  },
];

const REPEAT_RATES = [
  { label: 'Dubai Festival City', pct: 78, color: 'green' },
  { label: 'Marina Mall',         pct: 72, color: 'green' },
  { label: 'Abu Dhabi Mall',      pct: 68, color: ''      },
  { label: 'Al Wahda Mall',       pct: 55, color: ''      },
  { label: 'Yas Mall',            pct: 38, color: 'amber' },
];

const TIMING_LOCATIONS = [
  { name: 'Abu Dhabi Mall',      accept: '8 min',  start: '4 min', wash: '22 min', total: '34 min', badge: 'warn', badgeLabel: 'Slow'      },
  { name: 'Dubai Festival City', accept: '3 min',  start: '5 min', wash: '24 min', total: '32 min', badge: 'done', badgeLabel: 'Good'      },
  { name: 'Yas Mall',            accept: '14 min', start: '6 min', wash: '28 min', total: '48 min', badge: 'slow', badgeLabel: 'Very slow' },
  { name: 'Marina Mall',         accept: '4 min',  start: '3 min', wash: '20 min', total: '27 min', badge: 'done', badgeLabel: 'Good'      },
];

const LOCATION_TABLE = [
  { rank: 1, name: 'Abu Dhabi Mall',     sub: 'Al Reem Island, Abu Dhabi', orders: 47, gross: 'AED 2,108', payout: 'AED 1,939', rating: 4.7, accept: '8 min', repeat: '68%', status: 'done', statusLabel: 'Active',      acceptColor: '#d97706' },
  { rank: 2, name: 'Dubai Festival City',sub: 'Festival City, Dubai',      orders: 38, gross: 'AED 1,710', payout: 'AED 1,573', rating: 4.5, accept: '3 min', repeat: '78%', status: 'done', statusLabel: 'Active',      acceptColor: '#1a6641' },
  { rank: 3, name: 'Yas Mall',           sub: 'Yas Island, Abu Dhabi',     orders: 29, gross: 'AED 1,305', payout: 'AED 1,201', rating: 3.9, accept: '14 min',repeat: '38%', status: 'warn', statusLabel: 'Needs review',acceptColor: '#dc2626' },
  { rank: 4, name: 'Marina Mall',        sub: 'Dubai Marina, Dubai',       orders: 13, gross: 'AED 719',   payout: 'AED 661',   rating: 4.6, accept: '4 min', repeat: '72%', status: 'done', statusLabel: 'Active',      acceptColor: '#1a6641' },
];

const SAMPLE_REVIEWS = [
  { id: 1, name: 'Ahmed Al Farsi',  rating: 5, comment: 'Excellent service! Car was spotless. Will definitely book again.',       date: '2026-05-31 At 03:14 PM' },
  { id: 2, name: 'Sara Nasser',     rating: 4, comment: 'Good wash, took a bit longer than expected but quality was great.',      date: '2026-05-30 At 11:22 AM' },
  { id: 3, name: 'Anonymous',       rating: 3, comment: 'Average experience. Staff were polite but missed a spot on the hood.',   date: '2026-05-29 At 02:05 PM' },
];

// ──────────────────────────────────────────
// SUB-COMPONENTS
// ──────────────────────────────────────────

function StarRating({ value }) {
  return (
    <div className="review-stars">
      {[1, 2, 3, 4, 5].map(i => (
        <span key={i} className="star" style={{ color: i <= value ? '#f39d00' : '#ddd' }}>★</span>
      ))}
    </div>
  );
}

function LocationDropdown({ selected, onSelect }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function handleClick(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const allLabel = selected === 'all'
    ? LOCATIONS.all.label
    : (() => {
        for (const g of LOCATIONS.groups) {
          const shop = g.shops.find(s => s.value === selected);
          if (shop) return `📍 ${shop.label}`;
        }
        return LOCATIONS.all.label;
      })();

  return (
    <div className="loc-dropdown-wrapper" ref={ref}>
      <button className="loc-dropdown-btn" onClick={() => setOpen(o => !o)}>
        {allLabel}
        <span className={`chevron ${open ? 'open' : ''}`}>▼</span>
      </button>
      {open && (
        <div className="loc-dropdown-menu">
          <div
            className={`loc-menu-item all-opt ${selected === 'all' ? 'selected' : ''}`}
            onClick={() => { onSelect('all'); setOpen(false); }}
          >
            {LOCATIONS.all.label}
          </div>
          {LOCATIONS.groups.map(group => (
            <div key={group.city}>
              <div className="loc-menu-group-label">{group.city}</div>
              {group.shops.map(shop => (
                <div
                  key={shop.value}
                  className={`loc-menu-item ${selected === shop.value ? 'selected' : ''}`}
                  onClick={() => { onSelect(shop.value); setOpen(false); }}
                >
                  {shop.label}
                  <span style={{ fontSize: 10, color: '#aaa', marginLeft: 6 }}>{shop.sub}</span>
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ──────────────────────────────────────────
// TABS / VIEWS
// ──────────────────────────────────────────

function DashboardView({ period, location }) {
  const stats = STATS_BY_PERIOD[period] || STATS_BY_PERIOD.month;

  const locName = location === 'all'
    ? 'All locations'
    : (() => {
        for (const g of LOCATIONS.groups) {
          const s = g.shops.find(sh => sh.value === location);
          if (s) return s.label;
        }
        return 'All locations';
      })();

  return (
    <>
      {/* KPI STRIP */}
      <div className="kpi-strip">
        <div className="kpi-card purple">
          <div className="kpi-label">Total Orders</div>
          <div className="kpi-val purple">{stats.orders}</div>
          <div className="kpi-delta up">{stats.ordersDelta}</div>
        </div>
        <div className="kpi-card green">
          <div className="kpi-label">Accepted Orders</div>
          <div className="kpi-val green">{stats.accepted}</div>
          <div className="kpi-delta up">{stats.acceptedDelta}</div>
        </div>
        <div className="kpi-card amber">
          <div className="kpi-label">Cancelled Orders</div>
          <div className="kpi-val amber">{stats.cancelled}</div>
          <div className="kpi-delta">{stats.cancelledDelta}</div>
        </div>
        <div className="kpi-card dark">
          <div className="kpi-label">Avg Order Value</div>
          <div className="kpi-val white">{stats.avgOrder}</div>
          <div className="kpi-delta">↑ AED 3 vs last period</div>
        </div>
      </div>

      {/* REVENUE BREAKDOWN */}
      <div className="rev-box">
        <div className="rev-box-title">
          <span>Revenue breakdown · {locName} · {period === 'today' ? 'Today' : period === 'week' ? 'This Week' : period === 'month' ? 'May 2026' : 'All time'}</span>
          <span className="rev-box-sub">Commission rate per your platform agreement</span>
        </div>
        <div className="rev-row">
          <span className="rev-label">Gross revenue (shop price × completed orders)</span>
          <span className="rev-amount">{stats.revenue}</span>
        </div>
        <div className="rev-row">
          <span className="rev-label">Washta platform commission (8%)</span>
          <span className="rev-amount neg">− AED {stats.commission.toLocaleString()}.00</span>
        </div>
        <div className="rev-row total">
          <span className="rev-label" style={{ fontWeight: 700, fontSize: 13 }}>Your payout this period</span>
          <span className="rev-amount big">{stats.payout}</span>
        </div>
      </div>

      {/* CUSTOMER ACQUISITION */}
      <div className="section-label">Customer acquisition via Washta</div>
      <div className="cust-strip">
        <div className="cust-card">
          <div className="cust-val">{stats.newCustomers}</div>
          <div className="cust-lbl">New customers this month</div>
          <div className="cust-delta">↑ 12 more than last month</div>
        </div>
        <div className="cust-card green">
          <div className="cust-val">{stats.totalCust}</div>
          <div className="cust-lbl">Total customers acquired via Washta</div>
          <div className="cust-delta">Since platform launch</div>
        </div>
        <div className="cust-card neutral">
          <div className="cust-val">{stats.repeatRate}</div>
          <div className="cust-lbl">Returned for a second booking</div>
          <div className="cust-delta" style={{ color: '#4a3db8' }}>of first-time customers came back</div>
        </div>
      </div>

      {/* PEAK HOURS + BEST DAY */}
      <div className="section-label">Demand & service insights</div>
      <div className="charts-grid-2">
        <div className="chart-wrap" style={{ marginBottom: 0 }}>
          <div className="chart-head">
            <div>
              <div className="chart-title">Peak hours · orders by time of day</div>
              <div className="chart-sub">Based on order completion time</div>
            </div>
          </div>
          <div className="chart-body">
            {PEAK_HOURS.map(h => (
              <div className="bar-row" key={h.label}>
                <span className="bar-label">{h.label}</span>
                <div className="bar-track">
                  <div className={`bar-fill ${h.peak ? 'hi' : ''}`} style={{ width: `${h.pct}%` }} />
                </div>
                <span className="bar-val">{h.val}</span>
                {h.peak && <span className="bar-note">← peak</span>}
              </div>
            ))}
            <div className="chart-footnote">Peak window: <strong>2–4pm</strong> · ensure full staff coverage during this window</div>
          </div>
        </div>

        <div className="chart-wrap" style={{ marginBottom: 0 }}>
          <div className="chart-head">
            <div>
              <div className="chart-title">Best day of week · avg orders per day</div>
              <div className="chart-sub">Last 30 days · all locations</div>
            </div>
          </div>
          <div className="chart-body">
            {DAYS_OF_WEEK.map(d => (
              <div className="bar-row" key={d.label}>
                <span className="bar-label">{d.label}</span>
                <div className="bar-track">
                  <div className={`bar-fill ${d.peak ? 'hi' : ''}`} style={{ width: `${d.pct}%` }} />
                </div>
                <span className="bar-val">{d.val}</span>
                {d.peak && <span className="bar-note">← peak</span>}
              </div>
            ))}
            <div className="chart-footnote">Friday is <strong>3.2× busier</strong> than Monday · plan staffing accordingly</div>
          </div>
        </div>
      </div>

      {/* SERVICE MIX + CAR TYPE */}
      <div className="charts-grid-2">
        <div className="chart-wrap" style={{ marginBottom: 0 }}>
          <div className="chart-head">
            <div>
              <div className="chart-title">Service mix · what customers are booking</div>
              <div className="chart-sub">By order count and revenue contribution</div>
            </div>
          </div>
          <div className="chart-body">
            {SERVICE_MIX.map(s => (
              <div className="mix-row" key={s.label}>
                <span className="mix-label">{s.label}</span>
                <div className="mix-track"><div className="mix-fill" style={{ width: `${s.pct}%` }} /></div>
                <span className="mix-pct">{s.pct}%</span>
                <span className="mix-amt">{s.amt}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="chart-wrap" style={{ marginBottom: 0 }}>
          <div className="chart-head">
            <div>
              <div className="chart-title">Car type split · Sedan vs SUV</div>
              <div className="chart-sub">By revenue contribution</div>
            </div>
          </div>
          <div className="chart-body">
            {CAR_TYPES.map(c => (
              <div className="mix-row" key={c.label} style={{ marginBottom: 12 }}>
                <span className="mix-label" style={{ fontWeight: 600 }}>{c.label}</span>
                <div className="mix-track" style={{ width: 160, height: 10 }}>
                  <div className="mix-fill" style={{ width: `${c.pct}%`, background: c.color }} />
                </div>
                <span className="mix-pct" style={{ color: c.color }}>{c.pct}%</span>
                <span className="mix-amt">{c.amt}</span>
              </div>
            ))}
            <div style={{ height: 1, background: '#f0f0f0', margin: '10px 0 12px' }} />
            <div style={{ fontSize: 10, fontWeight: 700, color: '#111', marginBottom: 8 }}>Add-on upsell rate</div>
            {ADDONS.map(a => (
              <div className="mix-row" key={a.label}>
                <span className="mix-label" style={{ fontSize: 10 }}>{a.label}</span>
                <div className="mix-track"><div className="mix-fill" style={{ width: `${a.pct}%`, background: '#1a6641' }} /></div>
                <span className="mix-pct" style={{ color: '#1a6641' }}>{a.pct}%</span>
                <span className="mix-amt" style={{ color: '#1a6641' }}>{a.note}</span>
              </div>
            ))}
            <div className="chart-footnote">Upsell rate shows how often customers add extras — higher is better</div>
          </div>
        </div>
      </div>

      {/* RATING TREND + REPEAT BOOKING */}
      <div className="charts-grid-2">
        <div className="chart-wrap" style={{ marginBottom: 0 }}>
          <div className="chart-head">
            <div>
              <div className="chart-title">Rating trend · last 6 months</div>
              <div className="chart-sub">Average customer rating across all locations</div>
            </div>
          </div>
          <div className="chart-body">
            <div className="rating-trend-bars">
              {RATING_TREND.map(r => (
                <div className="rt-col" key={r.month}>
                  <div className="rt-num" style={r.top ? { color: '#4a3db8', fontWeight: 700 } : {}}>{r.val}</div>
                  <div className={`rt-bar ${r.top ? 'top' : r.hi ? 'hi' : ''}`} style={{ height: `${r.val * 10}px` }} />
                </div>
              ))}
            </div>
            <div className="rt-months">
              {RATING_TREND.map(r => (
                <div className="rt-month" key={r.month}>{r.month}</div>
              ))}
            </div>
            <div className="chart-footnote" style={{ color: '#1a6641', fontWeight: 600 }}>↑ Trending up · 3.8 → 4.7 over 6 months · keep it going</div>
          </div>
        </div>

        <div className="chart-wrap" style={{ marginBottom: 0 }}>
          <div className="chart-head">
            <div>
              <div className="chart-title">Repeat booking rate · per location</div>
              <div className="chart-sub">% of orders from customers who booked before</div>
            </div>
          </div>
          <div className="chart-body">
            {REPEAT_RATES.map(r => (
              <div className="bar-row" key={r.label}>
                <span className="bar-label wide">{r.label}</span>
                <div className="bar-track">
                  <div className={`bar-fill ${r.color}`} style={{ width: `${r.pct}%` }} />
                </div>
                <span className="bar-val" style={{ color: r.color === 'green' ? '#1a6641' : r.color === 'amber' ? '#d97706' : '#888', fontWeight: r.color ? 700 : 400 }}>
                  {r.pct}%
                </span>
              </div>
            ))}
            <div className="chart-footnote">Yas Mall at 38% is significantly below other locations — investigate service quality</div>
          </div>
        </div>
      </div>

      {/* ORDER TIMING */}
      <div className="section-label">Operational performance</div>
      <div className="chart-wrap">
        <div className="chart-head">
          <div>
            <div className="chart-title">Order timing · average time per stage</div>
            <div className="chart-sub">From customer booking received to wash completed · last 30 days</div>
          </div>
        </div>
        <div className="chart-body">
          <div className="timing-flow">
            <div className="timing-step">
              <div className="timing-lbl">Booking received</div>
              <div className="timing-dot" />
              <div className="timing-val muted">Start</div>
            </div>
            <div className="timing-arrow">→</div>
            <div className="timing-step">
              <div className="timing-lbl">Staff accepted</div>
              <div className="timing-dot" style={{ background: '#d97706' }} />
              <div className="timing-val warn">8 min</div>
            </div>
            <div className="timing-arrow">→</div>
            <div className="timing-step">
              <div className="timing-lbl">Wash started</div>
              <div className="timing-dot" style={{ background: '#1a6641' }} />
              <div className="timing-val good">4 min</div>
            </div>
            <div className="timing-arrow">→</div>
            <div className="timing-step">
              <div className="timing-lbl">Wash completed</div>
              <div className="timing-dot" style={{ background: '#1a6641' }} />
              <div className="timing-val good">22 min</div>
            </div>
            <div className="timing-arrow">→</div>
            <div className="timing-step">
              <div className="timing-lbl">Total time</div>
              <div className="timing-dot" style={{ background: '#4a3db8' }} />
              <div className="timing-val total">34 min</div>
            </div>
          </div>
          <div className="timing-note">⚠ Accept time target is under 5 min. Platform average is 8 min — check Yas Mall specifically (14 min).</div>

          <div style={{ marginTop: 16 }}>
            <div className="tbl-wrap">
              <table className="tbl">
                <thead>
                  <tr>
                    <th>Location</th>
                    <th className="r">Accept time</th>
                    <th className="r">Time to start</th>
                    <th className="r">Wash duration</th>
                    <th className="r">Total</th>
                    <th>Speed</th>
                  </tr>
                </thead>
                <tbody>
                  {TIMING_LOCATIONS.map(loc => (
                    <tr key={loc.name}>
                      <td style={{ fontWeight: 600 }}>{loc.name}</td>
                      <td className="r" style={{ fontWeight: 700, color: loc.badge === 'done' ? '#1a6641' : loc.badge === 'warn' ? '#d97706' : '#dc2626' }}>
                        {loc.accept}
                      </td>
                      <td className="r">{loc.start}</td>
                      <td className="r">{loc.wash}</td>
                      <td className="r" style={{ fontWeight: 700 }}>{loc.total}</td>
                      <td>
                        <span className={`pill pill-${loc.badge}`}>{loc.badgeLabel}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* LOCATION PERFORMANCE TABLE */}
      <div className="section-label">Location performance</div>
      <div className="sec-head">
        <div className="sec-title">All locations ranked by revenue · this period</div>
        <button className="export-btn">↓ Export</button>
      </div>
      <div className="chart-wrap" style={{ marginBottom: 22 }}>
        <div className="tbl-wrap">
          <table className="tbl">
            <thead>
              <tr>
                <th>#</th>
                <th>Location</th>
                <th className="r">Orders</th>
                <th className="r">Gross Revenue</th>
                <th className="r">Your Payout</th>
                <th className="r">Avg Rating</th>
                <th className="r">Accept Time</th>
                <th className="r">Repeat Rate</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {LOCATION_TABLE.map(row => (
                <tr key={row.rank}>
                  <td style={{ fontWeight: 700, color: '#4a3db8' }}>{row.rank}</td>
                  <td>
                    <div style={{ fontWeight: 600 }}>{row.name}</div>
                    <div style={{ fontSize: 9, color: '#aaa' }}>{row.sub}</div>
                  </td>
                  <td className="r">{row.orders}</td>
                  <td className="r">{row.gross}</td>
                  <td className="r" style={{ color: '#4a3db8', fontWeight: 700 }}>{row.payout}</td>
                  <td className="r" style={{ color: row.rating < 4 ? '#d97706' : undefined }}>⭐ {row.rating}</td>
                  <td className="r" style={{ color: row.acceptColor, fontWeight: 700 }}>{row.accept}{row.badge === 'slow' ? ' ⚠' : ''}</td>
                  <td className="r" style={{ color: parseInt(row.repeat) < 50 ? '#d97706' : undefined }}>{row.repeat}</td>
                  <td><span className={`pill pill-${row.status}`}>{row.statusLabel}</span></td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={2}>All locations</td>
                <td className="r">127</td>
                <td className="r">AED 5,842</td>
                <td className="r">AED 5,375</td>
                <td colSpan={4} />
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      {/* EMPLOYEE PERFORMANCE — Phase 2 */}
      <div className="section-label">Employee performance <span className="phase2-tag">Phase 2</span></div>
      <div className="phase2-block">
        <div className="phase2-icon">👤</div>
        <div className="phase2-title">Employee tracking coming soon</div>
        <div className="phase2-sub">
          Once employee IDs are added to the platform, you'll see per-employee stats here — orders completed, average acceptance time, average wash duration, and customer rating per staff member. Helps you identify your top performers and flag who needs support at which location.
        </div>
      </div>
    </>
  );
}

function OrdersView() {
  const orders = [
    { id: '#WA-2841', customer: 'Ahmed Al Farsi',  service: 'Interior + Exterior', location: 'Abu Dhabi Mall',      amount: 'AED 55', status: 'done', statusLabel: 'Completed', time: '2:34 PM' },
    { id: '#WA-2840', customer: 'Sara Nasser',      service: 'Exterior Wash',       location: 'Dubai Festival City', amount: 'AED 35', status: 'done', statusLabel: 'Completed', time: '1:18 PM' },
    { id: '#WA-2839', customer: 'Khalid Ibrahim',   service: 'Full Detail',         location: 'Marina Mall',         amount: 'AED 120',status: 'warn', statusLabel: 'In Process', time: '12:45 PM' },
    { id: '#WA-2838', customer: 'Noura Al Hamdan',  service: 'Exterior Wash',       location: 'Yas Mall',            amount: 'AED 35', status: 'slow', statusLabel: 'Cancelled', time: '11:20 AM' },
    { id: '#WA-2837', customer: 'Omar Rashid',      service: 'AC Sterilization',    location: 'Al Wahda Mall',       amount: 'AED 65', status: 'new',  statusLabel: 'Pending',   time: '10:05 AM' },
  ];
  return (
    <div className="chart-wrap">
      <div className="chart-head">
        <div>
          <div className="chart-title">Latest Orders</div>
          <div className="chart-sub">All locations · today</div>
        </div>
        <button className="export-btn">↓ Export</button>
      </div>
      <div className="tbl-wrap">
        <table className="tbl">
          <thead>
            <tr>
              <th>Order ID</th>
              <th>Customer</th>
              <th>Service</th>
              <th>Location</th>
              <th className="r">Amount</th>
              <th>Time</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {orders.map(o => (
              <tr key={o.id}>
                <td style={{ fontWeight: 700, color: '#4a3db8', fontFamily: 'monospace' }}>{o.id}</td>
                <td style={{ fontWeight: 600 }}>{o.customer}</td>
                <td>{o.service}</td>
                <td style={{ color: '#888', fontSize: 11 }}>{o.location}</td>
                <td className="r" style={{ fontWeight: 700 }}>{o.amount}</td>
                <td style={{ color: '#aaa', fontSize: 11 }}>{o.time}</td>
                <td><span className={`pill pill-${o.status}`}>{o.statusLabel}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function RatingsView() {
  const [reviews, setReviews] = useState(SAMPLE_REVIEWS);
  return (
    <div className="reviews-wrap">
      <div className="reviews-head">
        <span style={{ fontSize: 18 }}>⭐</span>
        <span className="reviews-head-title">Latest Reviews</span>
        <span style={{ fontSize: 11, color: '#888', marginLeft: 4 }}>{reviews.length} reviews</span>
      </div>
      {reviews.map(rev => (
        <div className="review-item" key={rev.id}>
          <div className="review-top">
            <span className="review-name">{rev.name}</span>
            <StarRating value={rev.rating} />
          </div>
          <p className="review-comment">{rev.comment}</p>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span className="review-date">{rev.date}</span>
          </div>
        </div>
      ))}
      {reviews.length === 0 && (
        <div style={{ padding: 32, textAlign: 'center', color: '#aaa', fontSize: 12 }}>No reviews yet</div>
      )}
    </div>
  );
}

function PlaceholderView({ title, icon }) {
  return (
    <div className="phase2-block" style={{ marginTop: 12 }}>
      <div className="phase2-icon">{icon}</div>
      <div className="phase2-title">{title}</div>
      <div className="phase2-sub">This section is currently being built. Check back soon for full functionality.</div>
    </div>
  );
}

// ──────────────────────────────────────────
// MAIN DASHBOARD
// ──────────────────────────────────────────
function Dashboard() {
  const [activeTab,   setActiveTab]   = useState('dashboard');
  const [period,      setPeriod]      = useState('month');
  const [location,    setLocation]    = useState('all');

  useEffect(() => { window.scrollTo(0, 0); }, []);

  // const NAV = [
  //   { id: 'dashboard',     icon: '📊', label: 'Dashboard'     },
  //   { id: 'orders',        icon: '📋', label: 'Orders'        },
  //   { id: 'shops',         icon: '🏪', label: 'Shops'         },
  //   { id: 'invoices',      icon: '🧾', label: 'Invoices'      },
  //   { id: 'ratings',       icon: '⭐', label: 'Ratings'       },
  //   { id: 'notifications', icon: '🔔', label: 'Notifications' },
  // ];

  const PERIODS = [
    { id: 'today', label: 'Today'      },
    { id: 'week',  label: 'This Week'  },
    { id: 'month', label: 'This Month' },
    { id: 'all',   label: 'All time'   },
  ];

  const renderView = () => {
    switch (activeTab) {
      case 'dashboard':     return <DashboardView period={period} location={location} />;
      case 'orders':        return <OrdersView />;
      case 'ratings':       return <RatingsView />;
      case 'shops':         return <PlaceholderView title="Shops" icon="🏪" />;
      case 'invoices':      return <PlaceholderView title="Invoices" icon="🧾" />;
      case 'notifications': return <PlaceholderView title="Notifications" icon="🔔" />;
      default:              return null;
    }
  };

  return (
  
      
     
          <div className='mainDiv-all-sideBar'>
    <div className='div-sidebar'>
<Sidebar/>
    </div>
    <div className='div-Dashbaord'>
    <h1 className='h1-all-heading'>Dashboard</h1>
    <div className="dashboard">

      {/* MAIN CONTENT */}
      <main className="washta-main">
        {/* TOP BAR */}
        <div className="page-topbar">
          {/* <h1 className="page-title">
            {NAV.find(n => n.id === activeTab)?.label || 'Dashboard'}
          </h1> */}
          {/* <span className="provider-chip">GeoWash</span> */}
        </div>

        {/* FILTER BAR — only on dashboard */}
        {activeTab === 'dashboard' && (
          <div className="filter-bar">
            <LocationDropdown selected={location} onSelect={setLocation} />
            <div className="filter-sep" />
            <div className="date-tabs">
              {PERIODS.map(p => (
                <button
                  key={p.id}
                  className={`date-tab ${period === p.id ? 'active' : ''}`}
                  onClick={() => setPeriod(p.id)}
                >
                  {p.label}
                </button>
              ))}
            </div>
            <button className="export-btn">↓ Export</button>
          </div>
        )}

        {/* VIEW */}
        {renderView()}
      </main>
    </div>
    </div>
    </div>
  );
}

export default Dashboard;